
// If you wish to display ONLY Apple Pay, use this standalone component.
// Note: It's typically recommended to use the all-in-one component in index.vue

import StripePayment from '@/services/payments/StripePayment';
import { loadStripe } from '@stripe/stripe-js';
import cartMixin from '@/mixins/cartMixin';

export default {
  mixins: [cartMixin],
  data() {
    return {
      stripe: null,
      elements: null,
      clientSecret: null,
      loading: true,
      expressCheckoutElement: null,
    };
  },
  computed: {
    stripePayment() {
      return new StripePayment({ cart: this.cart, http: this.$http });
    },
  },
  mounted() {
    loadStripe(process.env.STRIPE_PUBLIC_KEY).then(stripe => {
      this.stripe = stripe;
      this.initialize();
    });
  },
  methods: {
    async initialize() {
      try {
        const data = await this.stripePayment.intent({ paymentMethodTypes: 'card', isDigital: this.isDigitalCart });
        this.clientSecret = data.ClientSecret;

        if (this.clientSecret) {
          this.elements = this.stripe.elements({ clientSecret: this.clientSecret });
          
          this.expressCheckoutElement = this.elements.create('expressCheckout', {
            wallets: { applePay: 'always', googlePay: 'never', paypal: 'never', amazonPay: 'never' }
          });

          this.expressCheckoutElement.mount('#express-checkout-applepay-element');
          this.expressCheckoutElement.on('confirm', this.handleConfirm);
        }
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async handleConfirm(event) {
      const idorder = this.cart.IdCart;
      const { error, paymentIntent } = await this.stripe.confirmPayment({
        elements: this.elements,
        clientSecret: this.clientSecret,
        confirmParams: { return_url: `${process.env.URL}cart/thanks/accepted?orderid=${idorder}&cartid=${this.cartService.idCart}` },
        redirect: 'if_required',
      });
      if (!error && paymentIntent && paymentIntent.status === 'succeeded') {
        this.$router.push({
          path: this.localePath(`/cart/thanks/accepted?orderid=${idorder}&cartid=${this.cartService.idCart}`)
        });
      }
    }
  }
}
